import {matchPath} from "react-router-dom-v5-compat";

/**
 * Returns the Guide Activities slug from a given pathname if it represents a
 * Guide Activity page.
 *
 * @param {string} pathname The path to check.
 * @returns {?string} activitySlug if the path represents the activities page;
 * otherwise, `null`.
 */
export const getGuideActivitySlug = (pathname: string): string | null => {
    const match = matchPath(
        "/profile/me/khanmigo/activities/:activitySlug/:activitySubRouteSlug?",
        pathname,
    );
    return match?.params.activitySlug ?? null;
};
